import React from 'react';
import {Button, Link, Stack} from '@mui/material';
import NotFound from '../../components/Ui/NotFound';
import {useTranslation} from 'react-i18next';
import AdminLayout from '../layouts/AdminLayout';
import LinkOrExternal from '../../components/Router/LinkOrExternal';
import {config} from '../../config';
import {getAdminLocale} from '../../lib/localeHelper';

export default function MediumDisabled() {
    const {t, i18n} = useTranslation();

    const helpLocale = getAdminLocale(i18n.language);

    return (
        <AdminLayout>
            <NotFound
                title={t('admin:medium_disabled.title', 'VKARD is disabled')}
            >
                <Stack
                    sx={{
                        alignItems: 'center',
                        gap: 3,
                    }}
                >
                    <Button
                        variant={'contained'}
                        color={'info'}
                        component={LinkOrExternal}
                        to={config.homeUrl}
                    >
                        {t('admin:not_found.return_home', 'Return home')}
                    </Button>
                    <Link
                        href={`https://r.vkard.io/disabled-${helpLocale}`}
                        target={'_blank'}
                        rel={'noopener noreferrer'}
                    >
                        {t(
                            'admin:medium_disabled.why',
                            'Why is this VKARD disabled?',
                        )}
                    </Link>
                </Stack>
            </NotFound>
        </AdminLayout>
    );
}
